import { useState } from 'react';
import { Box, Heading, Stack, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { createProject } from '@/lib/api';
import { useProject } from '@/lib/ProjectContext';
import { toaster } from '@/components/ui/toaster';
import { EMPTY_PROJECT_FORM, ProjectForm, type ProjectFormValues } from './ProjectForm';

export function ProjectNew() {
  const navigate = useNavigate();
  const { refresh, setActiveProject } = useProject();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(values: ProjectFormValues) {
    setError(null);
    setSubmitting(true);
    try {
      const { id } = await createProject({
        code: values.code,
        name: values.name,
        description: values.description.trim() || null,
        address: values.address.trim() || null,
        countryCode: values.countryCode,
        departmentId: values.departmentId || null,
        municipalityId: values.municipalityId || null,
      });
      toaster.create({
        title: 'Proyecto creado',
        description: `${values.code} · ${values.name}`,
        type: 'success',
      });
      await refresh();
      setActiveProject(id);
      navigate('/proyectos');
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'No se pudo crear';
      setError(msg);
      toaster.create({ title: 'No se pudo crear el proyecto', description: msg, type: 'error' });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Box px={{ base: '4', md: '8' }} py={{ base: '6', md: '8' }}>
      <Stack gap="6" maxW="3xl">
        <Stack gap="1">
          <Text
            fontSize="xs"
            color="fg.muted"
            textTransform="uppercase"
            letterSpacing="0.06em"
            fontWeight="700"
          >
            Administración · Proyectos
          </Text>
          <Heading size="2xl" letterSpacing="-0.02em">
            Nuevo proyecto
          </Heading>
        </Stack>
        <ProjectForm
          initial={EMPTY_PROJECT_FORM}
          submitLabel="Crear proyecto"
          submitting={submitting}
          error={error}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/proyectos')}
        />
      </Stack>
    </Box>
  );
}
